import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ThemeMode = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private themeSubject = new BehaviorSubject<ThemeMode>('light');
  theme$ = this.themeSubject.asObservable();

  constructor() {
    this.initTheme();
  }

  toggleTheme() {
    const nextTheme: ThemeMode =
      this.themeSubject.value === 'dark' ? 'light' : 'dark';

    this.setTheme(nextTheme);
  }

  setTheme(theme: ThemeMode) {
    this.themeSubject.next(theme);
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }

  initTheme() {
    const saved = (localStorage.getItem('theme') as ThemeMode) || 'light';
    this.themeSubject.next(saved);
    document.body.setAttribute('data-theme', saved);
  }
}
